/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Breakpoint, HFlow, Icon, Icons, Text, Theme, Tooltip, useTheme } from 'bold-ui'
import { FontWeightProperty } from 'csstype'

export interface IconLabelProps {
  icon: Icons
  text: string
  color?: string
  textColor?: string
  hideTextBelow?: Breakpoint
  fontWeight?: FontWeightProperty
  hSpacing?: number
  size?: number
}

export function IconLabel(props: Readonly<IconLabelProps>) {
  const theme = useTheme()
  const {
    text,
    hideTextBelow,
    icon,
    textColor,
    color = theme.pallete.primary.c40,
    fontWeight,
    hSpacing = 0.3,
    size = 1,
  } = props

  const classes = createStyles(theme, textColor || color, hideTextBelow)

  return (
    <HFlow alignItems='center' hSpacing={hSpacing}>
      <Tooltip text={text} style={classes.tooltip}>
        <Icon icon={icon} color={color} size={size} />
      </Tooltip>

      <Text style={classes.text} fontWeight={fontWeight}>
        {text}
      </Text>
    </HFlow>
  )
}

const createStyles = (theme: Theme, textColor: string, hideTextBelow: Breakpoint) => ({
  tooltip: hideTextBelow
    ? css`
        ${theme.breakpoints.up(hideTextBelow)} {
          display: none;
        }
      `
    : css`
        display: none;
      `,
  text: hideTextBelow
    ? css`
        color: ${textColor};
        display: none;
        ${theme.breakpoints.up(hideTextBelow)} {
          display: inherit;
        }
      `
    : css`
        color: ${textColor};
      `,
})
